import moment from 'moment'

export const taskMixDrill = (days, today = moment()) => {
  const start = moment(today).format('YYYY-MM-DD')
  const soonEnd = moment(today).add(days, 'days').format('YYYY-MM-DD')
  const after = moment(today).add(days + 1, 'days').format('YYYY-MM-DD')
  return {
    upcoming: { open: 1, deadline_from: after },
    dueSoon: { open: 1, deadline_from: start, deadline_to: soonEnd },
    overdue: { overdue: 1 },
    onHold: { status: 'on_hold' },
    completedLate: { completed_late: 1 },
    completedOnTime: { status: 'completed' }
  }
}

export const REMEDIAL_MIX_LEAD = 'Open remedials now, and those resolved in the last 30 days.'
